export const CustomEventNames = Object.freeze({
  crm: {
    activities: {
      reloadActivityHome: 'reloadActivityHomeData',
    },
  },
  lighting: {
    reloadConfigHome: 'reloadLightingConfigHomeData',
  },
  measurements: {
    reloadHome: 'reloadMeasurementsHomeData',
  },
} as const);
